import ListingPrices from './ListingPrices.component';

export default ListingPrices;
